
import * as api from "../../../api"; 


  
export const loginLeadManager = (post) => async (dispatch)=>{
    try {
        const {data } = await api.loginLeadManager(post);
        //  console.log(data)
        if(data?.CRMtoken){
          dispatch({
            type: "LOGINLEAD",
            
            payload:data?.CRMtoken
          });  
       
        }else if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
        // dispatch({
        //     type: "LOGINLEAD",
            
        //     payload:null
        //   });  
    }
}

